import React from 'react';
import { Link } from 'react-router-dom';

export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Keep a console trace so local debugging still has the stack/context.
    // eslint-disable-next-line no-console
    console.error('Route render failed', error, info);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <main className="app-container">
          <section className="glass-card" style={{ padding: '1rem' }}>
            <h1 style={{ marginBottom: '0.5rem' }}>Something went wrong</h1>
            <p style={{ marginBottom: '1rem' }}>
              We hit an unexpected UI error while rendering this page.
            </p>
            <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
              <button type="button" className="refresh-button ripple" onClick={this.handleReset}>
                Try rendering again
              </button>
              <Link to="/leaderboard" className="refresh-button ripple">
                Back to leaderboard
              </Link>
              <Link to="/explore" className="refresh-button ripple">
                Go to explore
              </Link>
            </div>
            {this.state.error?.message ? (
              <p style={{ marginTop: '1rem', color: 'var(--text-muted)' }}>
                Error: {this.state.error.message}
              </p>
            ) : null}
          </section>
        </main>
      );
    }

    return this.props.children;
  }
}
